import { c as e } from "react/compiler-runtime";
import { BrowserAuthError as t, BrowserAuthErrorCodes as n, InteractionRequiredAuthError as r, InteractionStatus as i, InteractionType as a, LogLevel as o, createStandardPublicClientApplication as s } from "@azure/msal-browser";
import { MsalAuthenticationTemplate as c, MsalProvider as l, useMsal as u } from "@azure/msal-react";
import { createContext as d, useContext as f, useEffect as p, useRef as m, useState as h } from "react";
import { createPortal as g } from "react-dom";
import { Fragment as _, jsx as v, jsxs as y } from "react/jsx-runtime";
import b from "axios";
//#region src/config/Config.ts
var x = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, S = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? x.Local : t.startsWith("dev.") ? x.Dev : t.startsWith("stg.") ? x.Stg : x.Prd;
}, C = (e) => e !== x.Prd, w = (e, t) => {
	let n = e.VITE_REACT_APP_BRANCH_DEPLOYMENT === "true", r = n ? `${t}/redirect.html` : e.VITE_REACT_APP_ENV_SIGNIN_PREFIX, i = Object.entries(e).filter(([e]) => e.startsWith("VITE_REACT_APP_LOCAL_SERVICE_URI_")), a = {};
	for (let [e, t] of i) t && (a[e.replace("VITE_REACT_APP_LOCAL_SERVICE_URI_", "").toLowerCase()] = t);
	return {
		authClientId: e.VITE_REACT_APP_AUTH_CLIENT_ID,
		authInstance: e.VITE_REACT_APP_AUTH_INSTANCE,
		authDomain: e.VITE_REACT_APP_AUTH_DOMAIN,
		authSignupSigninPolicyId: e.VITE_REACT_APP_AUTH_SIGNIN_SIGNUP_POLICY_ID,
		envSigninPrefix: r,
		environment: n ? x.Dev : S(r),
		authEnableLogs: e.VITE_REACT_APP_LOG_AUTH,
		baseApiUri: e.VITE_REACT_APP_AGENTX_BASE_API,
		authAppUri: e.VITE_REACT_APP_AGENTX_AUTH_APP_URI,
		devMode: e.VITE_REACT_APP_DEV_MODE === "true",
		userIdClaim: e.VITE_REACT_APP_USERID_CLAIM,
		userTypeClaim: e.VITE_REACT_APP_USERTYPE_CLAIM,
		agencyClaim: e.VITE_REACT_APP_AGENCY_CLAIM,
		organisationIdClaim: e.VITE_REACT_APP_ORGANISATION_ID_CLAIM,
		rolesClaim: e.VITE_REACT_APP_ROLES_CLAIM,
		accessScopesClaim: e.VITE_REACT_APP_ACCESS_SCOPES_CLAIM,
		permissionsClaim: e.VITE_REACT_APP_PERMISSIONS_CLAIM,
		localUris: i.length > 0 ? a : void 0
	};
}, T = d({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	logout: async () => {
		throw Error("logout not initialized");
	},
	userAccount: {}
}), E = "AuthenticationStatus_page__8j2p0u0", D = "AuthenticationStatus_firstPaintOverlay__8j2p0u1 AuthenticationStatus_page__8j2p0u0", O = "AuthenticationStatus_content__8j2p0u2", k = "AuthenticationStatus_icon__8j2p0u3", A = "AuthenticationStatus_title__8j2p0u4", j = "AuthenticationStatus_message__8j2p0u5", M = "AuthenticationStatus_action__8j2p0u6", N = {
	alert: D,
	status: E
}, P = (t) => {
	let n = e(7), { children: r, role: i } = t, a = N[i], o = i === "alert" ? "assertive" : "polite", s;
	n[0] === r ? s = n[1] : (s = /* @__PURE__ */ v("section", {
		className: O,
		children: r
	}), n[0] = r, n[1] = s);
	let c;
	return n[2] !== i || n[3] !== a || n[4] !== o || n[5] !== s ? (c = /* @__PURE__ */ v("main", {
		className: a,
		role: i,
		"aria-live": o,
		children: s
	}), n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c) : c = n[6], c;
}, F = (t) => {
	let n = e(4), { message: r } = t, i, a;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ y("svg", {
		"aria-hidden": "true",
		width: "48",
		height: "48",
		viewBox: "0 0 48 48",
		fill: "none",
		className: k,
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			/* @__PURE__ */ v("path", {
				d: "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Zm0 36a16 16 0 1 1 0-32 16 16 0 0 1 0 32Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ v("path", {
				d: "M24 34a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ v("path", {
				d: "M24 14a2 2 0 0 0-2 2v10a2 2 0 1 0 4 0V16a2 2 0 0 0-2-2Z",
				fill: "currentColor"
			})
		]
	}), a = /* @__PURE__ */ v("h1", {
		className: A,
		children: "Unable to sign in"
	}), n[0] = i, n[1] = a) : (i = n[0], a = n[1]);
	let o = r ?? "We couldn't complete your sign-in. Please try again.", s;
	return n[2] === o ? s = n[3] : (s = /* @__PURE__ */ y(_, { children: [
		i,
		a,
		/* @__PURE__ */ v("p", {
			className: j,
			children: o
		})
	] }), n[2] = o, n[3] = s), s;
}, I = (e, t) => {
	let n = t, r = "unknown_error";
	typeof n?.errorCode == "string" ? r = n.errorCode : t instanceof Error && (r = t.name), console.error(e, {
		errorCode: r,
		subError: typeof n?.subError == "string" ? n.subError : void 0,
		correlationId: typeof n?.correlationId == "string" ? n.correlationId : void 0
	});
}, L = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ v(P, {
		role: "status",
		children: /* @__PURE__ */ v("p", {
			className: j,
			children: "Signing in..."
		})
	}), t[0] = n) : n = t[0], n;
}, ee = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ v(P, {
		role: "status",
		children: /* @__PURE__ */ v("p", {
			className: j,
			children: "Logging out..."
		})
	}), t[0] = n) : n = t[0], n;
}, te = ({ onSignOut: e }) => {
	let [t, n] = h(!1), [r, i] = h(!1), a = async () => {
		n(!0), i(!1);
		try {
			await e();
		} catch (e) {
			I("Sign-out failed", e), i(!0);
		} finally {
			n(!1);
		}
	};
	return /* @__PURE__ */ y(P, {
		role: "alert",
		children: [
			/* @__PURE__ */ v("h1", {
				className: A,
				children: "Access denied"
			}),
			/* @__PURE__ */ v("p", {
				className: j,
				children: "This account does not have access to this portal."
			}),
			/* @__PURE__ */ v("button", {
				type: "button",
				className: M,
				disabled: t,
				"aria-busy": t,
				onClick: () => void a(),
				children: t ? "Signing out..." : "Sign out"
			}),
			r && /* @__PURE__ */ v("p", {
				role: "status",
				children: "Sign-out failed. Please try again."
			})
		]
	});
}, R = ({ message: e, onTryAgain: t }) => {
	let [n, r] = h(!1), [i, a] = h(!1), o = async () => {
		r(!0), a(!1);
		try {
			await t();
		} catch (e) {
			I("Authentication recovery failed", e), a(!0);
		} finally {
			r(!1);
		}
	};
	return g(/* @__PURE__ */ y(P, {
		role: "alert",
		children: [
			/* @__PURE__ */ v(F, { message: e }),
			/* @__PURE__ */ v("button", {
				type: "button",
				"aria-busy": n,
				disabled: n,
				className: M,
				onClick: () => void o(),
				children: n ? "Trying again..." : "Try again"
			}),
			i && /* @__PURE__ */ v("p", {
				role: "status",
				className: "AuthenticationStatus_message__8j2p0u5",
				children: "Sign-in could not be restarted. Please try again."
			})
		]
	}), document.body);
}, z = (e, a, o) => {
	let s, c = i.None;
	return {
		getAuthToken: async () => {
			let l = {
				scopes: o,
				account: e
			};
			try {
				try {
					return (await a.acquireTokenSilent(l)).accessToken;
				} catch (e) {
					if (!(e instanceof t) || e.errorCode !== n.timedOut) throw e;
					return (await a.acquireTokenSilent(l)).accessToken;
				}
			} catch (e) {
				throw e instanceof r ? (!s && c === i.None && (s = a.acquireTokenRedirect(l).finally(() => {
					s = void 0;
				})), s && await s, e) : e;
			}
		},
		setInteractionStatus: (e) => {
			c = e;
		}
	};
}, ne = "https://login.microsoftonline.com/common/oauth2/v2.0/logout", re = (t) => {
	let n = e(27), { account: r, children: i, inProgress: a, instance: o, scopes: s } = t, c;
	n[0] !== r || n[1] !== o || n[2] !== s ? (c = z(r, o, s), n[0] = r, n[1] = o, n[2] = s, n[3] = c) : c = n[3];
	let l = c;
	l.setInteractionStatus(a);
	let u = l.getAuthToken, [d, f] = h(!1), p = m(void 0), g;
	n[4] !== r || n[5] !== o ? (g = async () => {
		if (p.current) return p.current;
		f(!0), p.current = o.logoutRedirect({
			account: r,
			postLogoutRedirectUri: ne
		});
		try {
			await p.current;
		} catch (e) {
			let t = e;
			throw p.current = void 0, f(!1), t;
		}
	}, n[4] = r, n[5] = o, n[6] = g) : g = n[6];
	let _ = g, y = r.idTokenClaims, b = y?.given_name, x = y?.family_name, S = `${y?.given_name} ${y?.family_name}`, C = y?.userId, w = y?.userType, E = y?.agent, D = y?.agency, O = y?.organisationId, k = y?.roles, A = y?.accessScopes, j = y?.permissions, M;
	n[7] !== O || n[8] !== k || n[9] !== A || n[10] !== j || n[11] !== b || n[12] !== x || n[13] !== S || n[14] !== C || n[15] !== w || n[16] !== E || n[17] !== D ? (M = {
		firstName: b,
		lastName: x,
		fullName: S,
		user: C,
		userType: w,
		agent: E,
		agency: D,
		organisationId: O,
		roles: k,
		accessScopes: A,
		permissions: j
	}, n[7] = O, n[8] = k, n[9] = A, n[10] = j, n[11] = b, n[12] = x, n[13] = S, n[14] = C, n[15] = w, n[16] = E, n[17] = D, n[18] = M) : M = n[18];
	let N = M, P;
	n[19] !== u || n[20] !== d || n[21] !== _ || n[22] !== N ? (P = {
		getAuthToken: u,
		logout: _,
		userAccount: N,
		isLoggingOut: d
	}, n[19] = u, n[20] = d, n[21] = _, n[22] = N, n[23] = P) : P = n[23];
	let F = P, I;
	return n[24] !== F || n[25] !== i ? (I = /* @__PURE__ */ v(T.Provider, {
		value: F,
		children: i
	}), n[24] = F, n[25] = i, n[26] = I) : I = n[26], I;
}, ie = (t) => {
	let n = e(33), { children: r, scopes: i } = t, { accounts: a, inProgress: o, instance: s } = u(), c;
	n[0] === s ? c = n[1] : (c = s.getActiveAccount(), n[0] = s, n[1] = c);
	let l = c, d;
	if (n[2] !== a || n[3] !== l) {
		if (l) {
			let e;
			n[5] === l ? e = n[6] : (e = (e) => e.homeAccountId === l.homeAccountId && e.localAccountId === l.localAccountId && e.username === l.username, n[5] = l, n[6] = e), d = a.find(e);
		} else a.length === 1 && (d = a[0]);
		n[2] = a, n[3] = l, n[4] = d;
	} else d = n[4];
	let f;
	n[7] !== a[0] || n[8] !== a.length || n[9] !== l || n[10] !== s ? (f = () => {
		!l && a.length === 1 && s.setActiveAccount(a[0]);
	}, n[7] = a[0], n[8] = a.length, n[9] = l, n[10] = s, n[11] = f) : f = n[11];
	let m;
	n[12] !== a || n[13] !== l || n[14] !== s ? (m = [
		a,
		l,
		s
	], n[12] = a, n[13] = l, n[14] = s, n[15] = m) : m = n[15], p(f, m);
	let h;
	n[16] !== d || n[17] !== a.length ? (h = () => {
		!d && a.length > 1 && console.error("Authentication account selection failed", {
			errorCode: "multiple_cached_accounts",
			subError: "active_account_missing",
			correlationId: void 0
		});
	}, n[16] = d, n[17] = a.length, n[18] = h) : h = n[18];
	let g;
	n[19] !== d || n[20] !== a.length ? (g = [d, a.length], n[19] = d, n[20] = a.length, n[21] = g) : g = n[21], p(h, g);
	let _;
	n[22] !== s || n[23] !== i ? (_ = async () => {
		await s.clearCache(), await s.loginRedirect({
			scopes: i,
			prompt: "login"
		});
	}, n[22] = s, n[23] = i, n[24] = _) : _ = n[24];
	let y = _;
	if (!d) {
		let e;
		return n[25] === y ? e = n[26] : (e = /* @__PURE__ */ v(R, { onTryAgain: y }), n[25] = y, n[26] = e), e;
	}
	let b;
	return n[27] !== d || n[28] !== r || n[29] !== o || n[30] !== s || n[31] !== i ? (b = /* @__PURE__ */ v(re, {
		account: d,
		inProgress: o,
		instance: s,
		scopes: i,
		children: r
	}), n[27] = d, n[28] = r, n[29] = o, n[30] = s, n[31] = i, n[32] = b) : b = n[32], b;
}, B = d(void 0), ae = (t) => {
	let n = e(2), { inProgress: r } = t, a;
	return n[0] === r ? a = n[1] : (a = r === i.Logout ? /* @__PURE__ */ v(ee, {}) : /* @__PURE__ */ v(L, {}), n[0] = r, n[1] = a), a;
}, oe = () => {
	let e = f(B);
	if (!e) throw Error("Authentication request is not initialized");
	return e;
}, se = (t) => {
	let n = e(10), { error: r, login: i } = t, { instance: o } = u(), s = oe(), c, l;
	n[0] === r ? (c = n[1], l = n[2]) : (c = () => {
		I("Authentication failed", r);
	}, l = [r], n[0] = r, n[1] = c, n[2] = l), p(c, l);
	let d;
	n[3] !== s || n[4] !== o || n[5] !== i ? (d = async () => {
		await o.clearCache(), await i(a.Redirect, {
			...s,
			prompt: "login"
		});
	}, n[3] = s, n[4] = o, n[5] = i, n[6] = d) : d = n[6];
	let f = d, m = r?.errorMessage, h;
	return n[7] !== f || n[8] !== m ? (h = /* @__PURE__ */ v(R, {
		message: m,
		onTryAgain: f
	}), n[7] = f, n[8] = m, n[9] = h) : h = n[9], h;
}, ce = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: r, envSigninPrefix: i, authEnableLogs: a }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!r) throw Error("authSignupSigninPolicyId is not set");
	if (!i) throw Error("envSigninPrefix is not set");
	let s;
	try {
		s = new URL(i);
	} catch {
		throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	}
	if (!s.pathname.endsWith("/redirect.html") || s.search !== "" || s.hash !== "") throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	let c = a === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${r}`,
			knownAuthorities: [t],
			redirectUri: s.href
		},
		cache: { cacheLocation: "localStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (c && !n) switch (e) {
				case o.Error:
					console.error(t);
					return;
				case o.Info:
					console.info(t);
					return;
				case o.Verbose:
					console.debug(t);
					return;
				case o.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, V = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, organisationIdClaim: r, rolesClaim: i, accessScopesClaim: a, permissionsClaim: o }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: t?.toLowerCase() === "platform" ? void 0 : e,
	agency: n,
	organisationId: r,
	roles: i?.split(",").map((e) => e.trim()).filter(Boolean),
	accessScopes: a?.split(",").map((e) => e.trim()).filter(Boolean),
	permissions: o?.split(",").map((e) => e.trim()).filter(Boolean)
}), H = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a = ue, o = de, s;
	n[0] === i ? s = n[1] : (s = V(i), n[0] = i, n[1] = s);
	let c = s, l;
	n[2] === c ? l = n[3] : (l = {
		getAuthToken: a,
		logout: o,
		userAccount: c
	}, n[2] = c, n[3] = l);
	let u = l, d;
	return n[4] !== u || n[5] !== r ? (d = /* @__PURE__ */ v(T.Provider, {
		value: u,
		children: r
	}), n[4] = u, n[5] = r, n[6] = d) : d = n[6], d;
}, U = ({ children: e, apiConfig: t }) => {
	let [n, r] = h(), [i, o] = h(!1);
	return p(() => {
		let e = (e) => {
			I("Failed to initialize authentication", e), o(!0);
		};
		try {
			if (!t.authAppUri) throw Error("authAppUri is not set");
			let n = { scopes: [`${t.authAppUri}/openid`] };
			s(ce(t)).then((e) => r({
				instance: e,
				authenticationRequest: n
			}), e);
		} catch (t) {
			e(t);
		}
	}, [t]), i ? /* @__PURE__ */ v(R, { onTryAgain: () => window.location.reload() }) : n ? /* @__PURE__ */ v(l, {
		instance: n.instance,
		children: /* @__PURE__ */ v(B.Provider, {
			value: n.authenticationRequest,
			children: /* @__PURE__ */ v(c, {
				interactionType: a.Redirect,
				authenticationRequest: n.authenticationRequest,
				loadingComponent: ae,
				errorComponent: se,
				children: /* @__PURE__ */ v(ie, {
					scopes: n.authenticationRequest.scopes,
					children: e
				})
			})
		})
	}) : /* @__PURE__ */ v(L, {});
}, W = (t) => {
	let n = e(2), { children: r, scope: i } = t, { userAccount: a, logout: o } = f(T);
	if (i && !a.accessScopes?.includes(i)) {
		let e;
		return n[0] === o ? e = n[1] : (e = /* @__PURE__ */ v(te, { onSignOut: o }), n[0] = o, n[1] = e), e;
	}
	return r;
}, le = (t) => {
	let n = e(9), { children: r, apiConfig: i, requiredAccessScope: a } = t, o;
	n[0] !== r || n[1] !== a ? (o = /* @__PURE__ */ v(W, {
		scope: a,
		children: r
	}), n[0] = r, n[1] = a, n[2] = o) : o = n[2];
	let s = o;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[3] !== i || n[4] !== s ? (e = /* @__PURE__ */ v(H, {
			apiConfig: i,
			children: s
		}), n[3] = i, n[4] = s, n[5] = e) : e = n[5], e;
	}
	let c;
	return n[6] !== i || n[7] !== s ? (c = /* @__PURE__ */ v(U, {
		apiConfig: i,
		children: s
	}), n[6] = i, n[7] = s, n[8] = c) : c = n[8], c;
};
async function ue() {
	return "local-dev-auth";
}
async function de() {}
//#endregion
//#region src/api/MaintenanceMode.ts
var G = "maintenance-mode-until", fe = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, K = "/", pe = (e) => {
	let t = e.headers?.[G];
	if (t === void 0) return;
	if (typeof t != "string" || !fe.test(t)) throw Error(`${G} must be a UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	let n = Date.parse(t);
	if (Number.isNaN(n) || new Date(n).toISOString().replace(".000Z", "Z") !== t) throw Error(`${G} must be a valid UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	return t;
}, q = (e) => {
	let t = pe(e);
	if (!t) return !1;
	let n = new URL(`${K}maintenance.html`, globalThis.location.origin);
	return n.searchParams.set(G, t), globalThis.location.replace(`${n.pathname}${n.search}`), !0;
}, J = () => new Promise(() => void 0), me = (e, t = "/") => (K = t, e.interceptors.response.use((e) => q(e) ? J() : Promise.resolve(e), (e) => b.isAxiosError(e) && e.response && q(e.response) ? J() : Promise.reject(e))), Y = "autopilot-sessionId", X = () => {
	let e = crypto.randomUUID();
	return sessionStorage.setItem(Y, e), e;
}, Z = () => sessionStorage.getItem("autopilot-sessionId") || X(), Q = /* @__PURE__ */ new WeakMap(), $ = (e) => typeof e == "object" && e ? Q.get(e) : void 0, he = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, organisationIdClaim: r, rolesClaim: i, accessScopesClaim: a, permissionsClaim: o }) => {
	let s = {};
	return e !== void 0 && (s["x-claim-userId"] = e), t !== void 0 && (s["x-claim-userType"] = t), n !== void 0 && (s["x-claim-agency"] = n), r !== void 0 && (s["x-claim-organisationId"] = r), i !== void 0 && (s["x-claim-roles"] = i), a !== void 0 && (s["x-claim-accessScopes"] = a), o !== void 0 && (s["x-claim-permissions"] = o), s;
}, ge = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			"x-session-id": Z(),
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = he(t);
	};
	async transformResult(e, t, n) {
		if (q(t)) return await new Promise(() => void 0);
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		if (t.status >= 200 && t.status < 300 && r.includes("application/json") && typeof i == "object" && i) return i;
		try {
			return await n(t);
		} catch (e) {
			throw typeof e == "object" && e && Q.set(e, t.status), e;
		}
	}
}, _e = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({}), ye = /* @__PURE__ */ function(e) {
	return e.Agency = "agency", e.Organisation = "organisation", e.Platform = "platform", e;
}({});
//#endregion
export { ye as AccessScope, _e as AgentRole, le as AgxAuth, x as AgxEnvironments, T as AuthContext, ge as AuthorizedApiBase, Y as BROWSER_SESSION_STORAGE_KEY, G as MAINTENANCE_MODE_UNTIL_HEADER, ve as StaffRole, w as createAgxConfig, $ as getApiErrorStatus, Z as getBrowserSessionId, C as isNonProductionEnvironment, q as redirectToMaintenancePage, me as registerMaintenanceModeInterceptor, S as resolveAgxEnvironment, X as startBrowserSession };

//# sourceMappingURL=index.js.map